import { APP_LINKS, APP_SUB_MENUS } from '@utils/variables';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { FC, useMemo } from 'react';
import { pushURL } from 'src/functions/functions';
import { ETextTransform } from 'src/styles/theme/components/NGText/NGText.enum';
import { EMediaQuery, ESize, ETextColor } from 'src/styles/theme/utils/enums';
import { NGTextEx, StyledLogo, StyledLogoImage } from './NGLogo.styles';
import { INGLogo } from './NGLogo.type';

const NGLogo: FC<INGLogo> = ({ size = ESize.l, betaVisible = false, ...otherProps }) => {
	const router = useRouter();

	const width = useMemo(() => {
		switch (size) {
			case ESize.s:
				return 120;
			case ESize.m:
				return 180;
			case ESize.l:
				return 240;
			case ESize.xl:
				return 360;
			default:
				return `
        100%;
      `;
		}
	}, [size]);

	return (
		<StyledLogo
			size={size}
			betaVisible={betaVisible}
			onClick={() => pushURL(APP_LINKS.home.href, APP_SUB_MENUS.home.overview.id)}
			{...otherProps}
		>
			<StyledLogoImage
				width={78}
				mdWidth={39}
				hiddenRanges={[
					[EMediaQuery.sm, EMediaQuery.md],
					[EMediaQuery.lg, EMediaQuery.max]
				]}
			>
				<Image priority src='/assets/ng_n_g_logo.svg' alt='logo of Node Guardians' layout='fill' draggable={false} />
			</StyledLogoImage>

			<StyledLogoImage
				width={width}
				hiddenRanges={[
					[EMediaQuery.min, EMediaQuery.sm],
					[EMediaQuery.md, EMediaQuery.lg]
				]}
			>
				<Image
					priority
					quality={100}
					src='/assets/logo-white.svg'
					alt='logo of Node Guardians'
					layout='fill'
					draggable={false}
				/>
			</StyledLogoImage>

			{betaVisible ? (
				<NGTextEx size={ESize.xs} textColor={ETextColor.gold} textTransform={ETextTransform.uppercase}>
					Beta
				</NGTextEx>
			) : null}
		</StyledLogo>
	);
};

export { NGLogo };
